<template>
  <li v-if="isInternalUser" class="sidebar-personalized">
    <div class="sidebar-shortcuts-actions">
        <button
          type="button"
          class="sidebar-shortcut-button"
          @click="openNavigationShortcuts('favorites')"
        >
          <i class="fa fa-star"></i>
          <span>Favorites</span>
        </button>
        <button
          type="button"
          class="sidebar-shortcut-button"
          @click="openNavigationShortcuts('recent')"
        >
          <i class="fa fa-history"></i>
          <span>Recent</span>
        </button>
      </div>
  </li>
</template>

<script setup>
defineProps({
  isInternalUser: {
    type: Boolean,
    default: false,
  },
});

function openNavigationShortcuts(tab) {
  window.dispatchEvent(new CustomEvent('open-navigation-shortcuts', { detail: { tab } }));
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/variables";

.sidebar-shortcuts-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.sidebar-shortcut-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  border: 1px solid rgba(67, 74, 115, 0.12);
  background: #fff;
  color: #52526c;
  border-radius: 6px;
  padding: 6px 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s, box-shadow 0.15s;
}

.sidebar-shortcut-button i {
  flex-shrink: 0;
  font-size: 14px;
}

.sidebar-shortcut-button span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-shortcut-button:hover {
  border-color: rgba($primary-color, 0.28);
  background: rgba($primary-color, 0.07);
  color: $primary-color;
  box-shadow: 0 2px 8px rgba($primary-color, 0.1);
}

.sidebar-utility-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  flex-shrink: 0;
  font-size: 12px;
}

.sidebar-personalized {
  padding: 10px;
}
</style>
